import once from 'lodash.once'
import React from 'react'
import { DndNavItem } from './types'

type dndContext<T> = {
  onItemDrop: (
    droppedItem: T,
    nextItem: T,
    parentId: string | undefined,
  ) => void
}

export const createDndTocContext = once(<T extends DndNavItem<T>>() =>
  React.createContext<dndContext<T>>({
    onItemDrop() {},
  }),
)

export const useDndTocContext = <T extends DndNavItem<T>>() =>
  React.useContext(createDndTocContext<T>())
